import React from "react";

import "./about.css";

import Menu from "../../components/menu/menu";

const About = () => {
  return (
    <>
      <Menu url="about" />

      <main className="about-page">
        <div className="about-container">
          <section className="about-section">
            <header className="about-header">
              <h1 className="about-title">
                Sobre mim
              </h1>

              <div className="title-divider"></div>
            </header>

            <div className="about-content">
              <p className="intro-text">
                Sou Desenvolvedor Full Stack Pleno, com forte atuação em
                backend e experiência no desenvolvimento de sistemas web
                robustos, escaláveis e orientados a boas práticas de
                arquitetura.
              </p>

              <p className="body-text">
                Atuo principalmente com{" "}
                <strong>PHP e Laravel</strong>, desenvolvendo APIs REST,
                regras de negócio, integrações com serviços externos,
                aplicações multi-tenant e processamento assíncrono com
                filas e Jobs.
              </p>

              <p className="body-text">
                Tenho experiência também no desenvolvimento frontend com{" "}
                <strong>React e JavaScript</strong>, além de trabalhar com{" "}
                <strong>MySQL/SQL, Docker, Git e ambientes Linux/Terminal</strong>.
              </p>

              <p className="body-text">
                Além do desenvolvimento hands-on, atuo como{" "}
                <strong>referência técnica</strong>, contribuindo com
                arquitetura, code reviews, definição de padrões, resolução
                de problemas complexos e apoio técnico ao time.
              </p>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default About;